import {ReactElement, useState} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Typography, useTheme} from "@mui/material";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Thumbs} from "swiper/modules";
import type {Swiper as SwiperType} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import {PD_SM, PD_XSM} from "@/shared/dimens";
import {GallerySectionData, SiteTemplate} from "../../types";

export function GallerySection(props: { data: GallerySectionData, template: SiteTemplate }): ReactElement {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);
  const theme = useTheme();

  if (!props.data.photos?.length) {
    return null;
  }

  return <div style={{width: "100%", padding: `2% 0 8% 0`, background: "#0E0025", color: "#fff"}}>
    <SectionContainer>
      <style>{`
        .fl-gallery-thumbs .swiper-slide { opacity: 0.4; cursor: pointer; transition: opacity 0.2s; border-radius: 0; overflow: hidden; }
        .fl-gallery-thumbs .swiper-slide:hover { opacity: 0.7; }
        .fl-gallery-thumbs .swiper-slide-thumb-active { opacity: 1; outline: 3px solid white; }
        .fl-gallery-main .swiper-button-prev,
        .fl-gallery-main .swiper-button-next { color: white; }
        .fl-gallery-main .swiper-button-prev::after,
        .fl-gallery-main .swiper-button-next::after { font-size: 18px; font-weight: bold; }
      `}</style>

      {props.data.title
        ? <StyledHeadingVariant default_={3} style={{color: "white"}}>{props.data.title}</StyledHeadingVariant>
        : null}

      <StyledBoxColumn style={{gap: PD_SM}}>
        <Swiper
          className="fl-gallery-main"
          modules={[Navigation, Thumbs]}
          navigation
          thumbs={{swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null}}
          style={{width: "100%", borderRadius: 0, overflow: "hidden"}}
        >
          {props.data.photos.map((photo, i) =>
            <SwiperSlide key={i}>
              <div style={{position: "relative", width: "100%", aspectRatio: "16/9"}}>
                <img
                  src={photo.imageUrl}
                  style={{width: "100%", height: "100%", objectFit: "cover", display: "block"}}/>
                {photo.caption
                  ? <div style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: `${PD_SM}px ${PD_SM * 2}px`,
                    background: "linear-gradient(transparent, rgba(0,0,0,0.5))",
                  }}>
                    <Typography style={{color: "white", fontWeight: "600"}}>
                      {photo.caption}
                    </Typography>
                  </div>
                  : null}
              </div>
            </SwiperSlide>
          )}
        </Swiper>

        <Swiper
          className="fl-gallery-thumbs"
          modules={[Thumbs]}
          onSwiper={setThumbsSwiper}
          watchSlidesProgress
          spaceBetween={PD_XSM}
          breakpoints={{
            0: {slidesPerView: 4},
            600: {slidesPerView: 6},
            900: {slidesPerView: 8},
          }}
          style={{width: "100%"}}
        >
          {props.data.photos.map((photo, i) =>
            <SwiperSlide key={i}>
              <img
                src={photo.imageUrl}
                style={{
                  width: "100%",
                  aspectRatio: "1",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: 0,
                }}/>
            </SwiperSlide>
          )}
        </Swiper>
      </StyledBoxColumn>
    </SectionContainer>
  </div>;
}
